/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_ImageInputs */

const en_image_inspector_image = /** @type {(inputs: Image_Inspector_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image`)
};

const ar_image_inspector_image = /** @type {(inputs: Image_Inspector_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الصورة`)
};

const bn_image_inspector_image = /** @type {(inputs: Image_Inspector_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ছবি`)
};

const de_image_inspector_image = /** @type {(inputs: Image_Inspector_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bild`)
};

const es_image_inspector_image = /** @type {(inputs: Image_Inspector_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imagen`)
};

const fr_image_inspector_image = /** @type {(inputs: Image_Inspector_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image`)
};

const pt_image_inspector_image = /** @type {(inputs: Image_Inspector_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imagem`)
};

const zh_image_inspector_image = /** @type {(inputs: Image_Inspector_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`图片`)
};

const tr_image_inspector_image = /** @type {(inputs: Image_Inspector_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Görsel`)
};

const ru_image_inspector_image = /** @type {(inputs: Image_Inspector_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изображение`)
};

const pl_image_inspector_image = /** @type {(inputs: Image_Inspector_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obraz`)
};

/**
* | output |
* | --- |
* | "Image" |
*
* @param {Image_Inspector_ImageInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_image = /** @type {((inputs?: Image_Inspector_ImageInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_ImageInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_image(inputs)
	if (locale === "bn") return bn_image_inspector_image(inputs)
	if (locale === "de") return de_image_inspector_image(inputs)
	if (locale === "es") return es_image_inspector_image(inputs)
	if (locale === "fr") return fr_image_inspector_image(inputs)
	if (locale === "pt") return pt_image_inspector_image(inputs)
	if (locale === "zh") return zh_image_inspector_image(inputs)
	if (locale === "tr") return tr_image_inspector_image(inputs)
	if (locale === "ru") return ru_image_inspector_image(inputs)
	if (locale === "pl") return pl_image_inspector_image(inputs)
	return en_image_inspector_image(inputs)
});